import { render } from "./GerenciaEscritorio.vue?vue&type=template&id=d4a8402a&scoped=true&ts=true"
import script from "./GerenciaEscritorio.vue?vue&type=script&lang=ts"
export * from "./GerenciaEscritorio.vue?vue&type=script&lang=ts"

import "./GerenciaEscritorio.vue?vue&type=style&index=0&id=d4a8402a&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d4a8402a"]])

export default __exports__